
export default {
  props: {
    isSecondFooter: {
      type: Boolean,
      default: false,
    },

    isFooterLp: {
      type: Boolean,
      default: false,
    },

    tel: {
      type: String,
      default: "01 84 74 17 17",
    },

    hrefTel: {
      type: String,
      default: "tel:+331-84-74-17-17",
    },

    isTypeform: {
      type: Boolean,
      default: true,
    },

    idTypeform: {
      type: String,
      default: "nVjz8LEL",
    },

    url: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      isOver: false,
      tintin: "",
      isTintin: false,
      isCalendlyActive: false,
    };
  },

  methods: {
    activeContact() {
      this.$root.$emit("Header");
    },

    tintinStart() {
      this.tintin = setTimeout(() => {
        this.isTintin = true;
      }, 30000);
    },

    tintinStop() {
      clearTimeout(this.tintin);
    },
  },
};
